import { jsx } from 'react/jsx-runtime';
import { twJoin } from 'tailwind-merge';
import Box from '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';
import NewCircle from './parts/NewCircle.js';
import New from './parts/New.js';
import Beta from './parts/Beta.js';
import Ai from './parts/Ai.js';
import 'react';

/**
 * 이미지에 오버레이되는 라벨을 표시하는 컴포넌트
 * @param {('new_circle'|'new'|'beta'|'ai')} props.type - 표시할 라벨의 타입
 * @returns {JSX.Element} 라벨 컴포넌트
 * @example
 * // NEW 원형 라벨
 * <ImageLabel type="new_circle" />
 *
 * // NEW 라벨
 * <ImageLabel type="new" />
 *
 * // BETA 라벨
 * <ImageLabel type="beta" />
 *
 * // AI 라벨
 * <ImageLabel type="ai" />
 *
 */ const ImageLabel = ({ type })=>{
    const Label = ()=>{
        switch(type){
            case 'new_circle':
                return /*#__PURE__*/ jsx(NewCircle, {});
            case 'new':
                return /*#__PURE__*/ jsx(New, {});
            case 'beta':
                return /*#__PURE__*/ jsx(Beta, {});
            case 'ai':
                return /*#__PURE__*/ jsx(Ai, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ jsx(Box, {
        "data-testid": "design-system-imageLabel",
        className: twJoin('h-fit w-fit text-primary', type !== 'new_circle' && 'pb-1.5'),
        children: /*#__PURE__*/ jsx(Label, {})
    });
};

export { ImageLabel as default };
